import React from 'react';
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";

function TooltipDesc({ description }) {
  return (
    <>
      <OverlayTrigger
        key='top'
        placement='top'
        overlay={
          <Tooltip id={'tooltip-top'}>
            <p>{description}</p>
          </Tooltip>
        }
      >
        <Button variant="secondary">!</Button>
      </OverlayTrigger>

    </>
  );
}

export default TooltipDesc



